<template>
  <div id="contenedor-listado-responsables-contrato-mobile">
    <v-card class="mt-4">
      <v-card-text>
        <v-list two-line>
          <template v-for="(responsable, index) in contratoResponsables">
            <v-list-item :key="`responsable-${index}`">
              <v-list-item-avatar>
                <avatar
                  tipo="nombre"
                  :size="64"
                  :nombre="responsable.funcionario.nombre"
                >
                </avatar>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  {{responsable.funcionario.nombre}}
                </v-list-item-title>
                <v-list-item-subtitle
                v-if="responsable.principal"
                class="text--primary">
                  <v-chip
                  color="success"
                  dark>
                    Residente de Obra
                  </v-chip>
                </v-list-item-subtitle>
                <v-list-item-subtitle
                class="text--primary">
                  {{responsable.funcionario.puesto}}
                </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn
                v-if="mixValidaScopesActions(3)"
                icon @click="borrarResponsableContrato(responsable)">
                  <v-icon> mdi-delete </v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
            <v-divider
              v-if="index < contratoResponsables.length - 1"
              :key="`divider-${index}`"
            >
            </v-divider>
          </template>
        </v-list>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import CONTRATO_RESPONSABLES from '@/graphql/querys/administracion/contratos/responsables/contratoResponsables.gql';
import Avatar from '@/components/Avatar.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ListadoResponsablesContratoMobile',
  components: {
    Avatar,
  },
  data() {
    return {};
  },
  apollo: {
    contratoResponsables: {
      query: CONTRATO_RESPONSABLES,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  methods: {
    borrarResponsableContrato(responsableContrato) {
      eventBus.$emit('borrar-responsable-contrato', responsableContrato);
    },
  },
};
</script>

<style lang="scss">

</style>
